import React, { useEffect, useRef, useState, useCallback } from 'react';
import { mqttPublish } from '@/utils/util';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useIsTakeOverBySelf } from '@/utils/hooks';

const RtcPlayer = (props: any) => {
  const isMountedRef = useRef(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const _RTCRef = useRef<any>(null);
  const rvfcIdRef = useRef<number | null>(null);
  const reconnectCountRef = useRef(0);
  const lastStatsRef = useRef<any>(null);
  const reportBufferRef = useRef<any>({});
  const latestDelayRef = useRef(0);
  const latestDelayWithRenderDelayRef = useRef(0);
  const latestClientDelayRef = useRef(0);
  const latestDecodeDelayRef = useRef(0);

  const latestDebugDelayARef = useRef(0);
  const latestDebugDelayBRef = useRef(0);
  const latestDebugDelayCRef = useRef(0);
  const latestDebugDelayDRef = useRef(0);

  const latestFrameTimeRef = useRef(0);
  const latestRenderTimeRef = useRef(0);
  const latestShowVideoIdRef = useRef(props.showVideoId);
  const takeOverBySelf = useIsTakeOverBySelf();
  const takeOverBySelfRef = useRef(takeOverBySelf);
  const [delayTime, setDelayTime] = useState(0);
  const cockpitNumber = useSelector(
    (state: RootState) => state.newCommon?.cockpitNumber
  );

  useEffect(() => {
    takeOverBySelfRef.current = takeOverBySelf;
  }, [takeOverBySelf]);
  useEffect(() => {
    latestShowVideoIdRef.current = props.showVideoId;
  }, [props.showVideoId]);

  const formatDelayTimeStamp = ({
    rtpTimestamp = 0,
  }: VideoFrameCallbackMetadata) => {
    if (rtpTimestamp === 0) return 0;
    const time = new Date();
    const now = Date.now();
    const time1 = new Date(
      `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()} 00:00:00`
    ).getTime();
    const t1 = now - time1;
    if (t1 >= 47721859) {
      rtpTimestamp = rtpTimestamp + 4294967295;
    }
    const renderTime = Date.now();
    const t2 = renderTime - (Math.floor(rtpTimestamp / 90) + time1);
    latestRenderTimeRef.current = renderTime;
    return t2;
  };

  const formatDelayWithRenderDelayTimeStamp = (
    {
      expectedDisplayTime = 0,
      presentationTime = 0,
      rtpTimestamp = 0,
    }: VideoFrameCallbackMetadata,
    now = 0
  ) => {
    const compareTime = Math.max(expectedDisplayTime, presentationTime);
    if (compareTime <= 0 || rtpTimestamp <= 0) return 0;

    const time = new Date();
    const time1 = new Date(
      time.getFullYear(),
      time.getMonth(),
      time.getDate()
    ).getTime();

    // 处理 rtpTimestamp 溢出
    const t1 = now + performance.timeOrigin - time1;
    let adjustedRtpTimestamp = rtpTimestamp;
    if (t1 >= 47721859) {
      adjustedRtpTimestamp = rtpTimestamp + 4294967295;
    }

    // 帧生成时间（绝对时间戳）
    const frameGenerationTime = Math.floor(adjustedRtpTimestamp / 90) + time1;

    // expectedDisplayTime 是相对于 timeOrigin 的，需要转换为绝对时间
    const absoluteCompareTime = compareTime + performance.timeOrigin;

    // 两个时间都是绝对时间戳，可以正常相减
    const delay = absoluteCompareTime - frameGenerationTime;

    return delay;
  };

  const formatDebugDelayTimeAStamp = (
    {
      expectedDisplayTime = 0,
      rtpTimestamp = 0,
    }: VideoFrameCallbackMetadata,
    now = 0
  ) => {
    const compareTime = Math.max(expectedDisplayTime, now);
    if (compareTime <= 0 || rtpTimestamp <= 0) return 0;

    const time = new Date();
    const time1 = new Date(
      time.getFullYear(),
      time.getMonth(),
      time.getDate()
    ).getTime();

    // 处理 rtpTimestamp 溢出
    const t1 = now + performance.timeOrigin - time1;
    let adjustedRtpTimestamp = rtpTimestamp;
    if (t1 >= 47721859) {
      adjustedRtpTimestamp = rtpTimestamp + 4294967295;
    }

    // 帧生成时间（绝对时间戳）
    const frameGenerationTime = Math.floor(adjustedRtpTimestamp / 90) + time1;

    // expectedDisplayTime 是相对于 timeOrigin 的，需要转换为绝对时间
    const absoluteCompareTime = compareTime + performance.timeOrigin;

    // 两个时间都是绝对时间戳，可以正常相减
    const delay = absoluteCompareTime - frameGenerationTime;

    return delay;
  };

  const formatDebugDelayTimeBStamp = (
    {
      expectedDisplayTime = 0,
      rtpTimestamp = 0,
    }: VideoFrameCallbackMetadata,
    now = 0
  ) => {
    const compareTime = Math.max(expectedDisplayTime, now);
    if (compareTime <= 0 || rtpTimestamp <= 0) return 0;


    const time = new Date();
    const time1 = new Date(
      `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()} 00:00:00`
    ).getTime();
    const t1 = Date.now() - time1;

    // 处理 rtpTimestamp 溢出
    let adjustedRtpTimestamp = rtpTimestamp;
    if (t1 >= 47721859) {
      adjustedRtpTimestamp = rtpTimestamp + 4294967295;
    }

    // 帧生成时间（绝对时间戳）
    const frameGenerationTime = Math.floor(adjustedRtpTimestamp / 90) + time1;

    // expectedDisplayTime 是相对于 timeOrigin 的，需要转换为绝对时间
    const absoluteCompareTime = compareTime + performance.timeOrigin;

    // 两个时间都是绝对时间戳，可以正常相减
    const delay = absoluteCompareTime - frameGenerationTime;

    return delay;
  };

  const formatDebugDelayTimeCStamp = (
    {
      expectedDisplayTime = 0,
      rtpTimestamp = 0,
    }: VideoFrameCallbackMetadata,
    now = 0
  ) => {
    const compareTime = Math.max(expectedDisplayTime, now);
    if (compareTime <= 0 || rtpTimestamp <= 0) return 0;


    const time = new Date();
    const time1 = new Date(
      `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()} 00:00:00`
    ).getTime();
    const t1 = Date.now() - time1;

    // 处理 rtpTimestamp 溢出
    let adjustedRtpTimestamp = rtpTimestamp;
    if (t1 >= 47721859) {
      adjustedRtpTimestamp = rtpTimestamp + 4294967295;
    }

    // 帧生成时间（绝对时间戳）
    const frameGenerationTime = Math.floor(adjustedRtpTimestamp / 90) + time1;

    // expectedDisplayTime 是相对于 timeOrigin 的，需要转换为绝对时间
    const absoluteCompareTime = compareTime + performance.timeOrigin;

    // 两个时间都是绝对时间戳，可以正常相减
    const delay = absoluteCompareTime - frameGenerationTime;

    return delay;
  };

  const formatFrameTimeStamp = ({
    rtpTimestamp = 0,
  }: VideoFrameCallbackMetadata) => {
    const time = new Date();
    if (rtpTimestamp === 0) {
      return 0;
    }
    const time1 = new Date(
      time.getFullYear(),
      time.getMonth(),
      time.getDate()
    ).getTime();
    const t1 = Date.now() - time1;
    let adjustedRtpTimestamp = rtpTimestamp;
    if (t1 >= 47721859) {
      adjustedRtpTimestamp = rtpTimestamp + 4294967295;
    }
    return Math.floor(time1 + adjustedRtpTimestamp / 90);
  };

  const formatDecodeTimeStamp = ({
    presentationTime = 0,
    receiveTime = 0,
  }: VideoFrameCallbackMetadata) => {
    return Number((presentationTime - receiveTime).toFixed(2));
  };

  const formatClientDelayTimeStamp = (
    { expectedDisplayTime = 0, receiveTime = 0 }: VideoFrameCallbackMetadata,
    now = 0
  ) => {
    const delay = Math.max(expectedDisplayTime, now) - receiveTime;
    return Number(delay.toFixed(2));
  };

  const clearAllResources = useCallback(() => {
    // 停止并清理 RTC 实例
    if (_RTCRef.current) {
      _RTCRef.current.ontrack = null;
      _RTCRef.current.onicecandidate = null;
      if (_RTCRef.current.pc) {
        try {
          _RTCRef.current.pc
            .getReceivers()
            .forEach((r: any) => r.track?.stop());
        } catch (e) {}
      }
      _RTCRef.current.close();
      _RTCRef.current = null;
    }

    // 强制重置 Video 元素
    if (videoRef.current) {
      const video = videoRef.current;
      if (rvfcIdRef.current !== null) {
        video.cancelVideoFrameCallback(rvfcIdRef.current);
        rvfcIdRef.current = null;
      }
      video.pause();
      if (video.srcObject instanceof MediaStream) {
        video.srcObject.getTracks().forEach((t) => t.stop());
      }
      video.srcObject = null;
      video.src = '';
      video.removeAttribute('src'); // 彻底移除
      video.load();
    }

    lastStatsRef.current = null;
    reportBufferRef.current = {};
  }, []);

  const frameCallbackLoop = (now: number, frame: any) => {
    if (!isMountedRef.current || !videoRef.current) {
      rvfcIdRef.current = null;
      return;
    }

    const delayMs = formatDelayTimeStamp(frame);
    const delayWithRenderDelayMs = formatDelayWithRenderDelayTimeStamp(
      frame,
      now
    );
    const calculatedDelay = Number((delayMs / 1000).toFixed(2));
    const calculateddelayWithRenderDelay = Number(
      (delayWithRenderDelayMs / 1000).toFixed(2)
    );
    const frameTime = formatFrameTimeStamp(frame);
    const clientDelay = formatClientDelayTimeStamp(frame, now);
    const debugDelayA = formatDebugDelayTimeAStamp(frame, now);

    const performanceNow = performance.now()

    const debugDelayB = formatDebugDelayTimeBStamp(frame, performanceNow);
    const debugDelayC = formatDebugDelayTimeCStamp(frame, performanceNow);
    const debugDelayD = formatDebugDelayTimeAStamp(frame, performanceNow);

    formatDebugDelayTimeAStamp
    const decodeDelay = formatDecodeTimeStamp(frame);
    latestDelayWithRenderDelayRef.current = calculateddelayWithRenderDelay;
    latestDelayRef.current = calculatedDelay;
    latestFrameTimeRef.current = frameTime;
    latestClientDelayRef.current = clientDelay;
    latestDecodeDelayRef.current = decodeDelay;

    latestDebugDelayARef.current = Number(debugDelayA.toFixed(2))
    latestDebugDelayBRef.current = Number(debugDelayB.toFixed(2))
    latestDebugDelayCRef.current = Number(debugDelayC.toFixed(2))
    latestDebugDelayDRef.current = Number(debugDelayD.toFixed(2))

    if (props.onFrameUpdate) props.onFrameUpdate(frameTime);

    rvfcIdRef.current =
      videoRef.current.requestVideoFrameCallback(frameCallbackLoop);
  };

  const startPlay = () => {
    if (!isMountedRef.current) return;
    clearAllResources();

    const win = window as any;
    if (!win.SrsRtcPlayerAsync) return;

    _RTCRef.current = new win.SrsRtcPlayerAsync();

    _RTCRef.current.ontrack = (event: any) => {
      if (!isMountedRef.current || !videoRef.current) return;
      const track = event?.track;
      if (track?.kind === 'video') {
        event.streams?.forEach((stream: any) => {
          if (videoRef.current) videoRef.current.srcObject = stream;
        });

        if (videoRef.current.requestVideoFrameCallback) {
          rvfcIdRef.current =
            videoRef.current.requestVideoFrameCallback(frameCallbackLoop);
        }
      }
    };

    _RTCRef.current.play(props.videoUrl).catch((e: any) => {
      console.error(`RTC Play Error (${props.videoId}):`, e);
      if (isMountedRef.current && reconnectCountRef.current < 5) {
        reconnectCountRef.current++;
        setTimeout(() => isMountedRef.current && startPlay(), 2000);
      }
    });
  };

  // 主播放器生命周期
  useEffect(() => {
    isMountedRef.current = true;
    startPlay();
    return () => {
      isMountedRef.current = false;
      clearAllResources();
    };
  }, [props.videoUrl]);

  useEffect(() => {
    const displayTimer = setInterval(() => {
      setDelayTime(latestDelayRef.current);
    }, 1000);

    const statsTimer = setInterval(() => {
      if (!isMountedRef.current || !_RTCRef.current?.pc) return;

      _RTCRef.current.pc.getStats(null).then((stats: any) => {
        if (!isMountedRef.current) return;
        stats.forEach((report: any) => {
          if (report.type === 'inbound-rtp' && report.kind === 'video') {
            const now = report.timestamp;
            const bytes = report.bytesReceived;
            const rid = report.id;

            if (lastStatsRef.current && lastStatsRef.current.has(rid)) {
              const prev = lastStatsRef.current.get(rid);
              const bitrate =
                (8 * (bytes - prev.bytesReceived)) / (now - prev.timestamp);

              if (props.getVideoBitRateInfo) props.getVideoBitRateInfo(bitrate);

              // 自动重连逻辑
              if (bitrate <= 0) {
                reconnectCountRef.current++;
                if (reconnectCountRef.current > 8) {
                  reconnectCountRef.current = 0;
                  startPlay();
                }
              } else {
                reconnectCountRef.current = 0;
              }

              // 写入缓冲区备用上报
              reportBufferRef.current[now] = {
                frameRate: report.framesPerSecond,
                bitRate: Math.ceil(bitrate),
                recordTime: Math.ceil(now),
                delayTime: latestDelayRef.current * 1000,
                delayWithRenderDelayTime:
                  latestDelayWithRenderDelayRef.current * 1000,
                clientDelay: latestClientDelayRef.current,
                decodeDelay: latestDecodeDelayRef.current,

                debugDelayA: latestDebugDelayARef.current,
                debugDelayB: latestDebugDelayBRef.current,
                debugDelayC: latestDebugDelayCRef.current,
                debugDelayD: latestDebugDelayDRef.current,

                showVideoId: latestShowVideoIdRef.current,
                frameTime: latestFrameTimeRef.current,
                takeOverBySelf: takeOverBySelfRef.current,
                renderTime: latestRenderTimeRef.current,
              };
            }
            if (!lastStatsRef.current) lastStatsRef.current = new Map();
            lastStatsRef.current.set(rid, report);
          }
        });
      });
    }, 1000);

    const mqttTimer = setInterval(() => {
      if (
        !isMountedRef.current ||
        !props.needSendData ||
        isEmpty(reportBufferRef.current)
      )
        return;

      const allKeys = Object.keys(reportBufferRef.current);
      if (allKeys.length >= 20) {
        const keysToSend = allKeys.slice(0, 20);
        const dataToSend = keysToSend.map(
          (key) => reportBufferRef.current[key]
        );

        mqttPublish(
          `${process.env.JDX_APP_SCREEN_DATA}/${props.userName}`,
          JSON.stringify({
            header: {
              messageType: 'VIDEO_DATA',
              requestId: Date.now(),
              clientName: cockpitNumber,
              requestTime: Date.now(),
              needResponse: false,
            },
            data: {
              userName: props.userName,
              vehicleName: props.vehicleName,
              recordList: dataToSend,
              videoId: props.videoId,
              cockpitNumber: cockpitNumber,
            },
          })
        );

        keysToSend.forEach((key) => {
          delete reportBufferRef.current[key];
        });
      }
    }, 3000);

    return () => {
      clearInterval(displayTimer);
      clearInterval(statsTimer);
      clearInterval(mqttTimer);
    };
  }, [
    props.videoId,
    props.needSendData,
    props.userName,
    props.vehicleName,
    cockpitNumber,
  ]);

  return (
    <div style={{ position: 'relative' }}>
      <video
        className="rtc_media_player"
        ref={videoRef}
        autoPlay
        muted
        playsInline
        style={{ width: '100%', height: '100%', display: 'block' }}
      ></video>
      <span
        className={`cbox vbox delay-time ${delayTime > 1 ? '' : 'grey'}`}
        style={{
          display: delayTime > 0 ? 'flex' : 'none',
          position: 'absolute',
          bottom: '10px',
          right: 'calc(50% - 8px)',
        }}
      >
        <img
          alt="delay"
          width={16}
          src={
            delayTime > 1
              ? require('@/assets/images/monitor/delay.png')
              : require('@/assets/images/monitor/grey-delay.png')
          }
        />
        <span style={{ color: '#fff' }}>{delayTime}s</span>
      </span>
    </div>
  );
};

export default React.memo(RtcPlayer);
